import styled from 'styled-components';

import { TrackedLink } from 'components/Link';
import { Link } from 'components/RouterLink';
import {
  colors,
  cssBreakpoints,
  gutterWidth,
  maxWidth,
  transition,
} from 'theme/theme';

export const PageFooterHolder = styled.footer<{ $showDivider: boolean }>`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: ${maxWidth[3]}px;
  max-width: 100%;
  padding-left: ${gutterWidth / 2}px;
  padding-right: ${gutterWidth / 2}px;
  padding-bottom: 20px;

  @media screen and (min-width: ${cssBreakpoints.mdUp}) {
    padding-left: ${gutterWidth}px;
    padding-right: ${gutterWidth}px;
  }

  @media screen and (max-width: ${cssBreakpoints.lgDown}) {
    padding-top: 20px;
  }

  @media screen and (min-width: ${cssBreakpoints.lgUp}) {
    padding-top: ${(props) => (props.$showDivider ? '20px' : 0)};
  }

  @media print {
    display: none;
  }
`;

export const PageFooterTrackedSocialLink = styled(TrackedLink)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 100%;
  background: ${colors.mediumSkyBlue};
  transition: ${transition};

  &:hover,
  &:focus {
    background: ${colors.hoverBlue};
  }
`;

export const PageFooterSectionsAndLogoMissionHolder = styled.div<{
  $showDivider: boolean;
}>`
  display: flex;
  border-top: ${(props) =>
    props.$showDivider ? `1px solid ${colors.selectionGrey}` : undefined};

  @media all and (max-width: ${cssBreakpoints.lgDown}) {
    flex-direction: column;
    padding-top: 20px;
  }

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    padding-top: 40px;
  }
`;

export const PageFooterSectionsHolder = styled.div`
  display: flex;

  @media all and (width <= 400px) {
    gap: 30px;
    flex-direction: column;
    align-items: center;
  }

  @media all and (width >= 400px) and (max-width: ${cssBreakpoints.lgDown}) {
    gap: 30px;
    justify-content: center;
  }

  @media all and (max-width: ${cssBreakpoints.lgDown}) {
    order: 2;
  }

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    gap: 34px;
  }
`;

export const PageFooterSectionHolder = styled.section<{
  $desktopOnly: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 150px;
  flex-shrink: 0;

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: ${(props) => (props.$desktopOnly ? 'none' : undefined)};
  }
`;

export const PageFooterSectionTitle = styled.h4`
  font-weight: normal;
  color: ${colors.mediumContentGrey};
  font-size: 20px;
  margin: 0;
`;

export const PageFooterSectionLinksHolder = styled.section`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const PageFooterSectionLink = styled(Link)`
  font-size: 16px;
  color: ${colors.lightContentGrey};

  &:not(:hover) {
    text-decoration: none;
  }
`;

export const PageFooterLogoMissionHolder = styled.section`
  display: flex;
  flex-direction: column;

  @media all and (max-width: ${cssBreakpoints.lgDown}) {
    order: 1;
    align-items: center;
    padding-bottom: 24px;
    border-bottom: 1px solid ${colors.selectionGrey};
    margin-bottom: 40px;
  }

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    margin-left: 40px;
  }
`;

export const PageFooterLogoLink = styled(Link)`
  margin-bottom: 24px;

  @media all and (max-width: ${cssBreakpoints.lgDown}) {
    display: none;
  }
`;

export const PageFooterMissionStatement = styled.p`
  font-size: 16px;
  line-height: 28.5px;
  margin: 0;
  color: ${colors.lightContentGrey};

  @media all and (max-width: ${cssBreakpoints.lgDown}) {
    text-align: center;
    width: 100%;
  }
`;

export const PageFooterSocialLinksHolder = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media all and (max-width: ${cssBreakpoints.lgDown}) {
    margin-top: 36px;
  }

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    margin-top: 40px;
  }
`;

export const PageFooterBottom = styled.div`
  display: flex;
  margin-top: 40px;

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    align-items: center;
    justify-content: space-between;
  }
`;

export const PageFooterCopyright = styled.div`
  font-size: 16px;
  color: ${colors.lightContentGrey};

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    width: 226px;
  }
`;
